import MyWorkProto from "../../my-work-properties/my-work-proto";
import Event from "../../event/event";
import {MY_WORK_ITEM_EVENT} from "../../my-work-properties/my-work-types"

// const debug = 'MyWorkEvent'
const debug = false

export default class MyWorkEvent extends MyWorkProto {

    private event: Event

    constructor(event: Event) {
        super()

        this.event = event

        debug && console.log(debug, 'constructor', this.event)
    }

    // schedule(date) {
    //     console.log("Schedule event called")
    // }

    get title() {return this.event.name}

    get isPastdue() {
        return this.event.isPastdue
    }

    // get canMoveToInbox() { return false }
    // get canMoveToSomeday() { return false }
    get canChangeDate() {
        return [
            gd.const.event.type.PROJECT_DEADLINE,
            gd.const.event.type.PROJECT_MILESTONE
        ].includes(this.event.eventType)
    }

    get myWorkId() { return this.event.rid }
    get myWorkType() {return MY_WORK_ITEM_EVENT}
    get fromUserId() {return this.event.createdByUserId}

    get dateCreated() {
        return this.event.dateCreated ? this.event.dateCreated : momentDate()
    }

    get isDateRange() {
        return [
            gd.const.event.type.PERSONAL_PAID_VACATION,
            gd.const.event.type.PERSONAL_SICK_LEAVE,
            gd.const.event.type.PERSONAL_TRAVEL,
            gd.const.event.type.COMPANY_EVENT,
            gd.const.event.type.COMPANY_HOLIDAY,
        ].includes(this.event.eventType)
    }

    get startDate() {
        return this.event.startDate
    }

    get endDate() {
        return this.event.endDate || this.event.startDate
    }
}
